import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const { Option } = Select;

const SimpleSelectSearch = ({
  options,
  onChange,
  value,
  disabled,
  chevronIconEnabled = true,
  ...rest
}) => {
  if (!options) {
    return null;
  }

  return (
    <Select
      showSearch
      allowClear
      style={{ width: '100%' }}
      disabled={disabled}
      value={value}
      onChange={(val) => {
        onChange(options.find((o) => o.value === val));
      }}
    >
      {options.length > 1 &&
        options.map((option) => (
          <Option value={option.value} key={option.value}>
            {option.name}
          </Option>
        ))}
    </Select>
  );
};

SimpleSelectSearch.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.any,
  disabled: PropTypes.any,
  chevronIconEnabled: PropTypes.bool,
};

export default SimpleSelectSearch;
